<ng-container *ngIf="isLoaded">
    <div class="firm-container layout-dashboard" [ngClass]="{'drawer-small': toggleMenu, 'drawer-full': !toggleMenu}">
        <header class="top-header">
            <div class="branding brand p-2" tabindex="0">
                <img class="full-logo" src="/assets/images/logo/countable-header-logo.svg" alt="Countable" />
            </div>
            <button mat-button type="button" class="menu-collapse-btn d-lg-none d-inline-flex" (click)="toggleDrawer()">
                <ng-container *ngIf="toggleMenu">
                    <i class="fa-regular fa-bars"></i>
                </ng-container>
                <ng-container *ngIf="!toggleMenu">
                    <i class="fa-regular fa-xmark clear-icon"></i>
                </ng-container>
            </button>
        </header>

        <div class="firm-body-container content-body">

            <aside class="left-sidebar" mode="side">
                <div class="brand" tabindex="0">
                    <img class="small-logo" src="/assets/images/global/brand/brand-small.svg" alt="Countable" />
                </div>

                <mat-list role="list" class="left-nav">
                    <mat-list-item role="list-item">
                        <span class="active nav-item">
                            <span class="nav-icon">
                                <img src="/assets/images/global/firm-onbording-icon.svg" alt="Icon">
                            </span>
                            <span class="nav-label">Firm Onboarding</span>
                        </span>
                    </mat-list-item>
                </mat-list>
            </aside>

            <!--Content-->
            <div class="dashboard-main">
                <div class="page-title-block">
                    <div class="title-left">
                        <h1 class="title h2">Welcome To Countable</h1>
                        <h5 class="sub-title">Please follow the four steps below to complete your account setup</h5>
                    </div>
                </div>

                <div class="content-block-main">
                    <mat-stepper class="countable-stepper vertical-stepper" [linear]="isLinear" #stepper>
                        <mat-step [stepControl]="firmSuperAdminForm">
                            <ng-template matStepLabel>
                                <div class="title cust-font">Account Information</div>
                            </ng-template>
                            <ng-container>
                                <div class="stepper-body-main card">
                                    <div class="card-header">
                                        <h5 class="title">Account Information</h5>
                                    </div>
                                    <form [formGroup]="firmSuperAdminForm" autoComplete="off" class="card-body gap-24">
                                        <div class="form-group row-item-4">
                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>Firm Name</mat-label>
                                                <input matInput formControlName="firmName" maxlength="100"
                                                    placeholder="Firstname" required>
                                            </mat-form-field>
                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>Address</mat-label>
                                                <input appFullAddress [country]="countryCodeForGoogleMap" matInput
                                                    placeholder="Address" formControlName="address" type="address"
                                                    (addressChange)="onAddressType($event)" required
                                                    onfocus="this.setAttribute('autocomplete', 'new-password')"
                                                    [matAutocomplete]="fullAddress">
                                                <mat-autocomplete #fullAddress="matAutocomplete"
                                                    (optionSelected)="selectedSuggestion($event, false)">
                                                    @for (option of autoCompleteSuggestions(); track option) {
                                                    <mat-option class="map-option" [value]="option">{{option.displayName}}</mat-option>
                                                    }
                                                </mat-autocomplete>
                                            </mat-form-field>

                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>City</mat-label>
                                                <input matInput placeholder="City" formControlName="city" type="address"
                                                    required>
                                            </mat-form-field>

                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>Province/State</mat-label>
                                                <input matInput placeholder="Province/State" formControlName="state"
                                                    type="address" required>
                                            </mat-form-field>

                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>Country</mat-label>
                                                <input matInput placeholder="Country" formControlName="country"
                                                    type="address" required>
                                            </mat-form-field>

                                            <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>Postal/Zip Code</mat-label>
                                                <input matInput maxlength="15" placeholder="Postal/Zip Code"
                                                    formControlName="zipCode" autocomplete="off"
                                                    (input)="alphaNumeric($event,'zipcode')" required
                                                    appDisableAutofill>
                                            </mat-form-field>

                                            <!-- here changed ng-select to mat-select now working fine but condition need to check developer (yes/no)-->
                                            <!-- <ng-container *ngIf=" loggedInUserData.origin_country_id == 38">
                                              <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                <mat-label>PEG/PACT Subscriber</mat-label>
                                                <mat-select formControlName="pegId"
                                                  (change)="onPegSubscriberChange()" placeholder="Select" required>
                                                  <mat-option [value]="folder.pegId" (change)="onPegSubscriberChange()" *ngFor="let folder of pegSubscriber">{{folder.pegName}}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </ng-container> -->

                                            <ng-container *ngIf=" user.origin_country_id == 38">
                                                <div class="form-item ng-form-field">
                                                    <label>PEG/PACT Subscriber<span class="required">*</span></label>
                                                    <ng-select appearance="outline" [items]="pegSubscriber"
                                                        bindLabel="pegName" bindValue="pegName" [virtualScroll]="true"
                                                        [clearable]="false" [clearOnBackspace]="false"
                                                        formControlName="pegId" aria-label="Select an option"
                                                        (change)="onPegSubscriberChange()" placeholder="Select"
                                                        [selectOnTab]="true" required>
                                                    </ng-select>
                                                </div>
                                            </ng-container>

                                            <ng-container
                                                *ngIf="isShowPEGSubcriberDetail && user.origin_country_id == 38">
                                                <mat-form-field class="form-item fixed-label">
                                                    <mat-label>License No.</mat-label>
                                                    <input matInput placeholder="License No."
                                                        formControlName="pegLicenseNo" maxlength="50" autocomplete="off"
                                                        (input)="alphaNumeric($event, 'pegLicenseNo')">
                                                </mat-form-field>

                                                <div class="fixed-label icon-form-right"
                                                    *ngIf="user.origin_country_id == 38">
                                                    <app-countable-date (selectedDate)="checkDates($event)"
                                                                        [label]="'Expiry Date'"
                                                                        [inputMinDate]="maxIncorpDate"
                                                                        [isMinDate]="true"
                                                        [subLabel]="'(MM/DD/YYYY)'" [placeholderText]="'MM/DD/YYYY'"
                                                        [inputDate]="firmSuperAdminForm.controls['pegExpiryDate'].value"></app-countable-date>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="form-lavel">
                                            <h5 class="title mb-20">Point of Contact</h5>
                                            <div class="form-group row-item-4">
                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Member ID</mat-label>
                                                    <input matInput placeholder="Member ID" formControlName="pMemberId"
                                                        maxlength="100" autocomplete="off"
                                                        (input)="alphaNumeric($event, 'pMemberId')">
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>License No</mat-label>
                                                    <input matInput placeholder="License No"
                                                        formControlName="pLicenseNo" maxlength="11" autocomplete="off"
                                                        (input)="handlePhone($event,'pLicenseNo')">
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>First Name</mat-label>
                                                    <input matInput placeholder="First Name" formControlName="firstName"
                                                        (input)="onlyChars($event,'firmadminfn')" maxlength="100"
                                                        autocomplete="off" required>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Last Name</mat-label>
                                                    <input matInput placeholder="Last Name" formControlName="lastName"
                                                        (input)="onlyChars($event,'firmadminln')" maxlength="100"
                                                        autocomplete="off" required>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Business Phone</mat-label>
                                                    <input matInput placeholder="Business Phone"
                                                        (input)="handlePhone($event,'business')" minlength="14"
                                                        maxlength="14" formControlName="businessPhone"
                                                        appDisableAutofill>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Cell Phone</mat-label>
                                                    <input matInput placeholder="Cell Phone"
                                                        (input)="handlePhone($event,'cell')" minlength="14"
                                                        maxlength="14" formControlName="cellPhone" appDisableAutofill>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput placeholder="Email" formControlName="email" readonly
                                                        required>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Hourly Rate</mat-label>
                                                    <input matInput placeholder="Hourly Rate"
                                                        formControlName="pHourlyRate" maxlength="15"
                                                        appCurrencyInputMask>
                                                </mat-form-field>

                                                <mat-form-field floatLabel="always" class="form-item fixed-label">
                                                    <mat-label>Title</mat-label>
                                                    <input matInput placeholder="Title" formControlName="pTitle"
                                                        maxlength="100" required>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="button-group justify-content-end mt-3 mt-md-4 mt-lg-5">
                                            <button mat-button mat-flat-button matStepperNext color="primary"
                                                type="submit" (click)="goToStep2()" class="button-medium"
                                                [disabled]="!firmSuperAdminForm.valid" title="Go to Step 2">
                                                <span class="flexbox-row gap-8">
                                                    <span class="button-label">
                                                        Go to Step 2
                                                    </span>
                                                    <i class="fa-regular fa-angle-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </ng-container>
                        </mat-step>

                        <mat-step [stepControl]="partnerDetailsForm">
                            <ng-template matStepLabel>
                                <div class="title cust-font">Add Team Members</div>
                            </ng-template>
                            <ng-container>
                                <div class="stepper-body-main gap-24">
                                    <div class="card">
                                        <div class="card-header">
                                            <h5 class="title">Add Team Members</h5>
                                        </div>
                                        <div class="card-body gap-24">

                                            <mat-radio-group [(ngModel)]="processType" class="horizontal-items">
                                                <mat-radio-button title="Add New Team Member" value="manual" checked
                                                    (click)="switchTabs($event,'manual', 'step-2')">
                                                    Add New Team Member
                                                    <span class="sub-text fw-normal">
                                                        (Add one member at a time)
                                                    </span>
                                                </mat-radio-button>
                                                <div (click)="switchTabs($event,'import', 'step-2')"
                                                    *ngIf="offSwitchTabs"></div>
                                                <mat-radio-button value="import"
                                                    (click)="switchTabs($event,'import', 'step-2')"
                                                    title=" Upload Existing Team">
                                                    Upload Existing Team
                                                    <span class="sub-text fw-normal">
                                                        (Add entire team in one go)
                                                    </span>
                                                </mat-radio-button>
                                            </mat-radio-group>

                                            <ng-container *ngIf="processType == 'manual'">
                                                <div class="upload-table fm-importpreview-table"
                                                    [ngClass]="{'addnew-section': processType == 'manual'}">
                                                    <div class="form-lavel mt-lg-4 mt-3"
                                                        *ngIf="processType == 'manual'">
                                                        <h5 class="title mb-20">Point of Contact</h5>
                                                        <form [formGroup]="partnerDetailsForm" #step2Form="ngForm">

                                                            <!-- <mat-radio-group class="horizontal-items mb-3">
                                                              <mat-radio-button title="{{UserRole.rolename}}" *ngFor="let UserRole of UserRole" [value]="UserRole.userroleid">
                                                                {{UserRole.rolename}}
                                                              </mat-radio-button>
                                                            </mat-radio-group> -->

                                                            <mat-radio-group class="horizontal-items mb-3"
                                                                [searchable]="false" formControlName="role">
                                                                <mat-radio-button title="{{UserRole.rolename}}"
                                                                    *ngFor="let UserRole of UserRole"
                                                                    [value]="UserRole.userroleid">
                                                                    {{ UserRole.rolename }}
                                                                </mat-radio-button>
                                                            </mat-radio-group>


                                                            <div class="form-group row-items-4">

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Member ID</mat-label>
                                                                    <input matInput placeholder="Member ID"
                                                                        formControlName="id"
                                                                        (input)="alphaNumeric($event, 'MEMBERId')"
                                                                        maxlength="100" (change)="validateStep2Id()"
                                                                        autocomplete="off">
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>License No</mat-label>
                                                                    <input matInput placeholder="License No"
                                                                        formControlName="licenseNo"
                                                                        (input)="handlePhone($event,'licenseNo')"
                                                                        maxlength="11" autocomplete="off"
                                                                        (blur)="validateStep2LicenseNo()"
                                                                        appDisableAutofill>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>First name</mat-label>
                                                                    <input matInput placeholder="First name"
                                                                        formControlName="partnerFirstName"
                                                                        (input)="onlyChars($event,'partnerfn')"
                                                                        autocomplete="off" maxlength="100" required>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Last name</mat-label>
                                                                    <input matInput placeholder="Last name"
                                                                        formControlName="partnerLastName"
                                                                        (input)="onlyChars($event,'partnerln')"
                                                                        autocomplete="off" maxlength="100" required>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Business Phone</mat-label>
                                                                    <input matInput placeholder="Business Phone"
                                                                        (input)="handlePhone($event,'pbnum')"
                                                                        minlength="14" maxlength="14"
                                                                        formControlName="partnerBusinessPhone"
                                                                        appDisableAutofill>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Cell phone</mat-label>
                                                                    <input matInput placeholder="Cell phone"
                                                                        (input)="handlePhone($event,'pcnum')"
                                                                        minlength="14" maxlength="14"
                                                                        formControlName="PartnerCellNo"
                                                                        autocomplete="off" appDisableAutofill>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label"
                                                                    [ngClass]="{'mat-form-field-invalid': isEmailS2Error}">
                                                                    <mat-label>Email</mat-label>
                                                                    <input #emailFieldStep2 matInput placeholder="Email"
                                                                        formControlName="partnerEmail"
                                                                        [value]="step2Email.value | lowercase"
                                                                        autocomplete="off" [readonly]="isReadonly"
                                                                        (blur)="validateStep2Email()" maxlength="100"
                                                                        required>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Hourly Rate</mat-label>
                                                                    <input matInput placeholder="Hourly Rate"
                                                                        formControlName="hourlyRate" maxlength="15"
                                                                        appCurrencyInputMask>
                                                                </mat-form-field>

                                                                <mat-form-field floatLabel="always"
                                                                    class="form-item fixed-label">
                                                                    <mat-label>Title</mat-label>
                                                                    <input matInput placeholder="Title"
                                                                        formControlName="title" autocomplete="off"
                                                                        maxlength="100" required appDisableAutofill>
                                                                </mat-form-field>

                                                                <div class="form-item ng-form-field">
                                                                    <label>Access Type <span
                                                                            class="required">*</span></label>
                                                                    <ng-select [items]="accessType"
                                                                        bindLabel="useraccessname"
                                                                        bindValue="useraccesstypeid"
                                                                        [virtualScroll]="true" [clearable]="false"
                                                                        [clearOnBackspace]="false"
                                                                        formControlName="accessType"
                                                                        (change)="selectedAccessTypeMember($event)"
                                                                        aria-label="Select an option" placeholder=""
                                                                        [selectOnTab]="true" required>
                                                                    </ng-select>
                                                                </div>

                                                            </div>
                                                            <div
                                                                class="button-group justify-content-end mt-3 mt-md-4 mt-lg-5">
                                                                <!-- Update partner start -->
                                                                <input type="hidden" formControlName="uniqueId">
                                                                <ng-container
                                                                    *ngIf="isEditPartner; else updateButtonMode">
                                                                    <button mat-button mat-stroked-button color="dark"
                                                                        class="button-medium" (click)="cancel()">
                                                                        <span class="btn-label">Cancel</span>
                                                                    </button>
                                                                    <button mat-button mat-flat-button color="primary"
                                                                        type="submit" class="button-medium"
                                                                        (click)="onEditPartner()"
                                                                        [disabled]="!partnerDetailsForm.valid || isInvalidEmail2 || isInvalidId2 || isInvalidName2 || isInvalidLicense">
                                                                        <span class="btn-label">Save</span>
                                                                    </button>
                                                                </ng-container>

                                                                <!--Add partner start -->
                                                                <ng-template #updateButtonMode>
                                                                    <button mat-button mat-flat-button color="primary"
                                                                        type="submit" class="button-medium"
                                                                        (click)="addPartner()"
                                                                        [disabled]="!partnerDetailsForm.valid || isInvalidEmail2">
                                                                        <span class="btn-label">Add Team Member</span>
                                                                    </button>
                                                                </ng-template>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="processType == 'import'">
                                                <div class="file-upload" appDragDrop
                                                    (onFileDropped)="uploadListener($event, 'dnd', 'step-2')">
                                                    <div class="upload-icon">
                                                        <i class="fa-regular fa-cloud-arrow-up"></i>
                                                    </div>
                                                    <div class="file-wrapper">
                                                        <input type="file" #csvReader name="photo" id="photo"
                                                            (change)="uploadListener($event, 'manual', 'step-2')"
                                                            accept=".csv" />
                                                        <p class="text-link text-primary fw-medium m-0">Click to upload
                                                            <span class="text-gray-6 fw-regular">or drag and drop</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="button-group align-items-strached column-gap-20 text-center"
                                                    style="width: 560px;max-width: 100%">
                                                    <button mat-button mat-stroked-button color="#004b92"
                                                        class="button-medium flex-1" (click)="editCsv()"
                                                        title="Guide to Create Template">Guide to Create Template
                                                    </button>
                                                    <a mat-button mat-flat-button color="primary" target="_blank"
                                                        class="button-medium flex-1" title="Download Template"
                                                        href="{{partnerCSVUrl | async}}">Download Template</a>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <ng-container *ngIf="partnersGridData.length > 0">
                                            <div class="card-header">
                                                <div class="header-left">
                                                    <h5 class="title">Team Members</h5>
                                                    <!-- <p class="text-error m-0" *ngIf="partnerEmailStatus || partnerIdStatus || partnerLicenseNostatus">
                                                  <i class="fa-regular fa-circle-exclamation"></i>
                                                      Member Id/Email Id/License No already exist. Please re-check the record information
                                                    </p> -->
                                                </div>
                                                <form class="header-right form-group m-0">
                                                    <mat-form-field
                                                        class="fixed-label label-none flex-1 icon-form-before"
                                                        floatLabel="always">
                                                        <mat-label>Search</mat-label>
                                                        <input matInput placeholder="Search" maxlength="50"
                                                            (keyup)="applyPartnerFilter($event.target.value)"
                                                            autocomplete="off">
                                                        <span matPrefix>
                                                            <i class="fa-regular fa-magnifying-glass"
                                                                draggable="false"></i>
                                                        </span>
                                                    </mat-form-field>
                                                </form>
                                            </div>

                                            <!-- <div class="card-body fm-tbl-grid-container table-grid-step2 five-step-partner-grid" -->
                                            <div class="card-body p-0 gap-24">
                                                <div class="table-responsive"
                                                    [ngClass]="{'step2-man': processType == 'manual' , 'step2-imp': processType == 'import' }">
                                                    <table mat-table [dataSource]="actualPartnersGridData"
                                                        class="table-countable">
                                                        <ng-container matColumnDef="id">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-id" title="Member ID"> Member ID
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-id" title="{{element.id}}">
                                                                <p
                                                                    [ngClass]="[(element.duplicateIDStatus === 1 || element.duplicateIDStatus === 2 || element.duplicateIDStatus === 3) ? 'grid-colorchange' : ' ']">
                                                                    {{ element.id ? element.id : "-" }} </p>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="role">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-role" title=" Category"> Category
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-role" title="{{element.role}}">
                                                                <p> {{ element.role }}</p>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="name">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-name" title="Name">Name
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-name">
                                                                <p
                                                                    title="{{element.partnerFirstName + ' ' + element.partnerLastName}}">
                                                                    {{ element.partnerFirstName + ' ' +
                                                                    element.partnerLastName }}
                                                                </p>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="title">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-title" title="Title"> Title
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-title" title="Manager">
                                                                <span class="ellipse">{{ element.title }}</span>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="email">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-email" title="Email"> Email
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-email"
                                                                title="{{element.partnerEmail}}">
                                                                <a href="mailto:{{element.partnerEmail}}"
                                                                    class="ellipse tab-email text-link"
                                                                    [ngClass]="[(element.emailValidationStatus === 1 || element.emailValidationStatus === 2 || element.emailValidationStatus === 3) ? 'grid-colorchange' : ' ']">{{
                                                                    element.partnerEmail }}</a>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="businessNumber">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-number" title="Business Phone">
                                                                Business Phone
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-number"
                                                                title="{{element.partnerBusinessPhone ? element.partnerBusinessPhone : '-'}}">
                                                                <p>{{ element.partnerBusinessPhone ?
                                                                    element.partnerBusinessPhone :
                                                                    "-" }} </p>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="cell">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-cell" title="Cell Phone"> Cell
                                                                Phone
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-cell"
                                                                title="{{element.PartnerCellNo ? element.PartnerCellNo : '-'}}">
                                                                <p> {{ element.PartnerCellNo ? element.PartnerCellNo :
                                                                    "-" }} </p>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="rate">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-rate" title="Hourly Rate">
                                                                <div class="flex-box-vc-hr"> Hourly Rate</div>
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-rate"
                                                                title="{{element.hourlyRate | currency :'':''}}">
                                                                <div class="flex-box-vc-hr">
                                                                    <p> {{ element.hourlyRate ? (element.hourlyRate |
                                                                        currency
                                                                        :'':'') : '-' }} </p>
                                                                </div>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="access">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-rate" title="Access Type"> Access
                                                                Type
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-rate"
                                                                title="{{element.accessType ? element.accessType : '-'}}">
                                                                <p> {{ element.accessType ? element.accessType : '-' }}
                                                                </p>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="license">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-licence" title="License No">
                                                                <div class="flex-box-vc-hr ls-right"> License No</div>
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-licence"
                                                                title="{{element.licenseNo}}">
                                                                <div class="flex-box-vc-hr ls-right">
                                                                    <p
                                                                        [ngClass]="[(element.duplicateLicenseNoStatus === 1 || element.duplicateLicenseNoStatus === 2 || element.duplicateLicenseNoStatus === 3) ? 'grid-colorchange' : ' ']">
                                                                        {{ element.licenseNo ? element.licenseNo : "-"
                                                                        }}</p>
                                                                </div>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="actions" stickyEnd>
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-action " title="Actions">
                                                                <div class="actions-items acts-item">Actions</div>
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="overflow-auto">
                                                                <div class="actions-items acts-item">
                                                                    <button mat-button title="Edit"
                                                                        class="button-small-icon-action"
                                                                        (click)="editPartner(element)">
                                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                                    </button>
                                                                    <button mat-button mat-flat-button title="Delete"
                                                                        class="button-small-icon-action"
                                                                        (click)="deleteDialog(element)">
                                                                        <i class="fa-regular fa-trash-can"></i>
                                                                    </button>
                                                                    <!-- <button class="transparent-btn" title="Edit" (click)="editPartner(element)">
                                                                <i class="fa-regular fa-pen grid-icon"></i>
                                                                    </button>
                                                                    <button class="transparent-btn" title="Delete" (click)="deleteDialog(element)"
                                                                      [disabled]="element.isEditMode">
                                              <i class="fa-regular fa-trash-can"></i>
                                                                    </button> -->
                                                                </div>
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row
                                                            *matHeaderRowDef="addPartnersColumns; sticky: true"></tr>
                                                        <tr mat-row
                                                            *matRowDef="let row; columns: addPartnersColumns; let i = index"
                                                            [ngClass]="[(i == 0 && processType == 'manual')? 'latest-row':'']">
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="card-footer button-group">
                                                <button mat-button mat-flat-button color="primary"
                                                    class="button-medium me-auto" matStepperPrevious
                                                    (click)="activeStep1()">
                                                    <span class="flexbox-row gap-8">
                                                        <i class="fa-regular fa-angle-left"></i>
                                                        <span class="button-label">Back</span>
                                                    </span>
                                                </button>
                                                <button mat-button mat-flat-button color="secondary"
                                                    class="button-medium" matStepperNext (click)="skipSecondStep()">
                                                    <span class="btn-label">Skip</span>
                                                </button>
                                                <button mat-button mat-flat-button class="button-medium" color="primary"
                                                    [disabled]="onStep2ValidationClick()" (click)="validateSecondStep()"
                                                    matStepperNext>
                                                    <span class="flexbox-row gap-8">
                                                        <span class="button-label">
                                                            Go to Step 3
                                                        </span>
                                                        <i class="fa-regular fa-angle-right"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </mat-step>

                        <mat-step [stepControl]="clientDetailsForm">
                            <ng-template matStepLabel>
                                <div class="title cust-font">Add Clients (Optional)</div>
                            </ng-template>
                            <ng-container>
                                <div class="stepper-body-main gap-24">
                                    <div class="card">
                                        <div class="card-header">
                                            <h5 class="title">Add Clients (Optional)</h5>
                                        </div>

                                        <div class="card-body gap-24">

                                            <mat-radio-group [(ngModel)]="processType" class="horizontal-items">
                                                <mat-radio-button value="manual" checked
                                                    (click)="switchTabs($event,'manual', 'step-3')">
                                                    Add New Client
                                                    <span class="sub-text fw-normal">
                                                        (Add one client at a time)
                                                    </span>
                                                </mat-radio-button>

                                                <mat-radio-button value="import"
                                                    (click)="switchTabs($event,'import', 'step-3')">
                                                    Upload Existing Clients
                                                    <span class="sub-text fw-normal">
                                                        (Add entire client list in one go)
                                                    </span>
                                                </mat-radio-button>
                                            </mat-radio-group>

                                            <ng-container *ngIf="processType == 'import'">
                                                <div class="file-upload" appDragDrop
                                                    (onFileDropped)="uploadListener($event, 'dnd', 'step-3')">
                                                    <div class="upload-icon">
                                                        <i class="fa-regular fa-cloud-arrow-up"></i>
                                                    </div>
                                                    <div class="file-wrapper">
                                                        <input type="file" #csvReader name="photo" id="photo"
                                                            (change)="uploadListener($event, 'manual', 'step-3'); $event.target.value = ''"
                                                            accept=".csv" />
                                                        <p class="text-link text-primary fw-medium m-0">Click to upload
                                                            <span class="text-gray-6 fw-regular">or drag and drop</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="button-group align-items-strached column-gap-20 text-center"
                                                    style="width: 560px;max-width: 100%">
                                                    <button mat-button mat-stroked-button color="#004b92"
                                                        class="button-medium flex-1" (click)="editCsvCli()"
                                                        title="Guide to Create Template">Guide to Create Template
                                                    </button>
                                                    <a mat-button mat-flat-button color="primary" target="_blank"
                                                        class="button-medium flex-1" title="Download Template"
                                                        href="{{clientCSVUrl | async}}">Download Template</a>
                                                </div>
                                            </ng-container>


                                            <ng-container *ngIf="processType == 'manual'">
                                                <form [formGroup]="clientDetailsForm" autoComplete="off"
                                                    #step3Form="ngForm">
                                                    <div class="form-group row-item-4">
                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Client ID</mat-label>
                                                            <input matInput placeholder="Client ID"
                                                                formControlName="clientId"
                                                                (input)="alphaNumeric($event, 'CLIENTID')"
                                                                (change)="validateStep3Id()" maxlength="100">
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label"
                                                            [ngClass]="{'mat-form-field-invalid': isEntityError}">
                                                            <mat-label>Entity Name</mat-label>
                                                            <input #entityField matInput placeholder="Entity Name"
                                                                formControlName="legalEntityName" maxlength="100"
                                                                (input)="removeErr()" required>
                                                        </mat-form-field>

                                                        <div class="form-item fixed-label icon-form-after">
                                                            <app-countable-date [isMaxDate]="true"
                                                                [inputMaxDate]="maxIncorpDate"
                                                                (selectedDate)="errorMsg($event,!step3Date.valid)"
                                                                [label]="customDateTitle" [subLabel]="'(MM/DD/YYYY)'"
                                                                [placeholderText]="'MM/DD/YYYY'"
                                                                [inputDate]="clientDetailsForm.controls['incorporationDate'].value"></app-countable-date>
                                                        </div>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Group Name</mat-label>
                                                            <input matInput placeholder="Group Name"
                                                                formControlName="groupName" maxlength="100">
                                                        </mat-form-field>

                                                        <div class="form-item ng-form-field">
                                                            <label>Entity Type<span class="required">*</span></label>
                                                            <ng-select [items]="typeOfEntityDetails"
                                                                bindLabel="typeofentityname" bindValue="typeofentityid"
                                                                [virtualScroll]="true" [clearable]="false"
                                                                [clearOnBackspace]="false"
                                                                formControlName="typeOfEntity"
                                                                (change)="onEntityChange()" [(ngModel)]="typeofentityid"
                                                                placeholder="Entity Type" [selectOnTab]="true" required>
                                                                <ng-template ng-option-tmp let-item="item">
                                                                    <div title="{{item.typeofentityname}}">{{
                                                                        item.typeofentityname }}</div>
                                                                </ng-template>
                                                            </ng-select>
                                                        </div>

                                                        <div class="form-item ng-form-field"
                                                            *ngIf="user.origin_country_id == 226">
                                                            <label>Entity Sub Type<span
                                                                    class="required">*</span></label>
                                                            <ng-select [items]="subtypeOfEntityDetails"
                                                                bindLabel="subentityname" bindValue="typeofsubentityid"
                                                                [virtualScroll]="true" [clearable]="false"
                                                                [clearOnBackspace]="false"
                                                                formControlName="subentitysectionData"
                                                                [(ngModel)]="typeofsubentityid"
                                                                placeholder="Entity Sub Type" [selectOnTab]="true"
                                                                required>
                                                                <ng-template ng-option-tmp let-item="item">
                                                                    <div title="{{item.subentityname}}">{{
                                                                        item.subentityname }}</div>
                                                                </ng-template>
                                                            </ng-select>
                                                        </div>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>First Name</mat-label>
                                                            <input matInput placeholder="First Name"
                                                                formControlName="clientFirstName"
                                                                (input)="onlyChars($event,'clientfn')" maxlength="50"
                                                                required>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Last Name</mat-label>
                                                            <input matInput placeholder="Last Name"
                                                                formControlName="clientLastName"
                                                                (input)="onlyChars($event,'clientln')" maxlength="50"
                                                                required>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Business Phone</mat-label>
                                                            <input matInput placeholder="Business Phone"
                                                                formControlName="clientBusinessPhone"
                                                                (input)="handlePhone($event,'clientbnum')"
                                                                minlength="14" maxlength="14" appDisableAutofill>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Cell Phone</mat-label>
                                                            <input matInput placeholder="Cell Phone"
                                                                formControlName="clientCellPhone"
                                                                (input)="handlePhone($event,'clientcnum')"
                                                                minlength="14" maxlength="14" appDisableAutofill>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label"
                                                            [ngClass]="{'mat-form-field-invalid': isEmailError}">
                                                            <mat-label>Email</mat-label>
                                                            <input #emailField matInput placeholder="Email"
                                                                formControlName="clientEmail"
                                                                [value]="ClientEmail.value | lowercase"
                                                                (input)="validateStep3Email()" maxlength="100" required>
                                                            <mat-error
                                                                *ngIf="!ClientEmail.valid && ClientEmail.touched">

                                                            </mat-error>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Address</mat-label>
                                                            <input appFullAddress [country]="countryCodeForGoogleMap"
                                                                   matInput placeholder="Address"
                                                                formControlName="clientAddress" type="address"
                                                                (addressChange)="onAddressType($event)"
                                                                (keydown.enter)="$event.preventDefault()"
                                                                onfocus="this.setAttribute('autocomplete', 'new-password')"
                                                                [matAutocomplete]="clientFullAddress">
                                                            <mat-autocomplete #clientFullAddress="matAutocomplete"
                                                                (optionSelected)="selectedSuggestion($event, true)">
                                                                @for (option of autoCompleteSuggestions(); track option)
                                                                {
                                                                <mat-option class="map-option"
                                                                    [value]="option">{{option.displayName}}</mat-option>
                                                                }
                                                            </mat-autocomplete>
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>City</mat-label>
                                                            <input matInput placeholder="City"
                                                                formControlName="clientCity" type="address">
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Province/State</mat-label>
                                                            <input matInput placeholder="Province/State"
                                                                formControlName="clientState" type="address">
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Country</mat-label>
                                                            <input matInput placeholder="Country"
                                                                formControlName="clientCountry" type="address">
                                                        </mat-form-field>

                                                        <mat-form-field floatLabel="always"
                                                            class="form-item fixed-label">
                                                            <mat-label>Postal/Zip Code</mat-label>
                                                            <input matInput (input)="alphaNumeric($event)"
                                                                maxlength="15" placeholder="Postal/Zip Code"
                                                                formControlName="clientZipCode"
                                                                (input)="alphaNumeric($event,'czipCode')"
                                                                appDisableAutofill>
                                                        </mat-form-field>

                                                        <div class="form-item ng-form-field required">
                                                            <label>Engagement Partner</label>
                                                            <ng-select [items]="partnersList"
                                                                formControlName="engPartner" bindLabel="fullName"
                                                                bindValue="fullName" placeholder="Engagement Partner"
                                                                [clearable]="false" [clearOnBackspace]="false"
                                                                [selectOnTab]="true" required>
                                                                <ng-template ng-option-tmp let-item="item"
                                                                    let-index="index" let-search="searchTerm">
                                                                    <div class="partner-view user-list-item"
                                                                        (click)="engagementPartner(item)">
                                                                        <ngx-avatars size="28" initialsSize="2"
                                                                            [name]="item.partnerFirstName+' '+item.partnerLastName"></ngx-avatars>
                                                                        <div class="item-content">
                                                                            <p class="name"
                                                                                title="{{item.partnerFirstName+' '+item.partnerLastName}}"
                                                                                [ngOptionHighlight]="search">{{
                                                                                item.partnerFirstName + ' ' +
                                                                                item.partnerLastName }}</p>
                                                                            <p class="mail"
                                                                                title="{{item.partnerEmail}}"
                                                                                [ngOptionHighlight]="search">{{
                                                                                item.partnerEmail }}</p>
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                            </ng-select>
                                                        </div>
                                                        <input type="hidden" formControlName="uniqueId">
                                                    </div>
                                                </form>
                                            </ng-container>

                                        </div>

                                        <div class="card-footer button-group column-gap-20 justify-content-end">
                                            <ng-container *ngIf="isEditClient; else updateClientButtonMode">
                                                <button mat-button mat-stroked-button color="dark" class="button-medium"
                                                    (click)="step3Cancel()">
                                                    Cancel
                                                </button>
                                                <button type="submit" mat-button mat-flat-button color="dark"
                                                    class="button-medium" color="primary"
                                                    (click)="onEditClientNameEntity()"
                                                    [disabled]="!clientDetailsForm.valid || isInvalidId3 || isInvalidEmail3">
                                                    Save
                                                </button>
                                            </ng-container>
                                            <ng-template #updateClientButtonMode>
                                                <button type="submit" mat-button mat-flat-button class="button-medium"
                                                    color="primary"
                                                    [disabled]="!clientDetailsForm.valid || isInvalidId3 || isInvalidEmail3"
                                                    (click)="validateClientNameEntity()">
                                                    Add Client Member
                                                </button>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="card">

                                        <ng-container *ngIf="clientsGridData.length > 0">
                                            <div class="card-header">
                                                <div class="header-left">
                                                    <h5 class="title">Clients</h5>
                                                    <p class="m-0 text-error"
                                                        *ngIf="clientEmailStatus || clientIdStatus">
                                                        <i class="fa-regular fa-circle-exclamation"></i>
                                                        Client Id/Email Id already exist. Please re-check the record
                                                        information
                                                    </p>
                                                </div>
                                                <div class="header-right column-gap-20">
                                                    <div class="asign-partner" style="position: relative;">
                                                        <button mat-button mat-stroked-button color="dark"
                                                            class="button-medium" [matMenuTriggerFor]="menu"
                                                            *ngIf="isEnableAssignButton">
                                                            <div class="flexbox-row gap-8">
                                                                <i class="fa-regular fa-user-plus"></i>
                                                                <span class="button-label">Assign Partner</span>
                                                                <i class="fa-solid fa-angle-down fs-15"></i>
                                                            </div>
                                                        </button>

                                                        <mat-menu #menu="matMenu" #beforeMenu="matMenu"
                                                            xPosition="before" YPosition="below">
                                                            <div class="h-100 overflow-hidden d-flex flex-column"
                                                                (click)="$event.stopPropagation()">
                                                                <form
                                                                    class="d-flex flex-column gap-8 p-2 border-bottom w-100">
                                                                    <mat-form-field
                                                                        class="fixed-label label-none icon-form-before w-100 form-field-medium"
                                                                        floatLabel="always">
                                                                        <mat-label>Search</mat-label>
                                                                        <input matInput placeholder="Search"
                                                                            [(ngModel)]="searchFilter"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (click)="$event.stopPropagation()"
                                                                            autocomplete="off">
                                                                        <span matPrefix>
                                                                            <i class="fa-regular fa-magnifying-glass"
                                                                                draggable="false"></i>
                                                                        </span>
                                                                    </mat-form-field>
                                                                    <button mat-button type="button"
                                                                        class="button-text ms-auto"
                                                                        (click)="unAssignPartnerToCLients()">
                                                                        <span class="flexbox-row gap-8">
                                                                            <i class="fa-regular fa-user-xmark"></i>
                                                                            <span class="button-label">Unassign</span>
                                                                        </span>
                                                                    </button>
                                                                </form>
                                                                <ul class="templates-list-items h-100 overflow-auto">
                                                                    <li class="list-item-content h-auto py-2"
                                                                        *ngFor="let partner of partnersList | searchFilter"
                                                                        (click)="assignPartnerToCLient(partner)">
                                                                        <div class="partner-view user-list-item">
                                                                            <ngx-avatars size="24" initialsSize="2"
                                                                                [name]="partner.partnerFirstName+' '+partner.partnerLastName"></ngx-avatars>
                                                                            <div class="item-content">
                                                                                <p class="name"
                                                                                    title="{{partner.partnerFirstName+' '+partner.partnerLastName}}">
                                                                                    {{ partner.partnerFirstName + ' ' +
                                                                                    partner.partnerLastName }}</p>
                                                                                <p class="mail"
                                                                                    title="{{partner.partnerEmail}}">{{
                                                                                    partner.partnerEmail }}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </mat-menu>
                                                    </div>

                                                    <form class="form-group">
                                                        <mat-form-field
                                                            class="fixed-label label-none flex-1 icon-form-before"
                                                            floatLabel="always">
                                                            <mat-label>Search</mat-label>
                                                            <input matInput placeholder="Search"
                                                                (keyup)="applyClientFilter($event.target.value)">
                                                            <span matPrefix>
                                                                <i class="fa-regular fa-magnifying-glass"
                                                                    draggable="false"></i>
                                                            </span>
                                                        </mat-form-field>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="card-body gap-24 p-0">

                                                <div class="table-responsive"
                                                    [ngClass]="{'step3-man': processType == 'manual' , 'step3-imp': processType == 'import' }">
                                                    <table mat-table [dataSource]="actualClientsGridData"
                                                        class="table-countable checkbox-table">
                                                        <ng-container matColumnDef="checkbox">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-checkbox">
                                                                <mat-checkbox (click)="$event.stopPropagation()"
                                                                    (change)="isSelectedAll($event)"
                                                                    [checked]="isCheckedAll" [disabled]="isEditClient">
                                                                </mat-checkbox>
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-checkbox">
                                                                <mat-checkbox (click)="$event.stopPropagation()"
                                                                    [(ngModel)]="element.isChecked"
                                                                    (change)="isSelected()" [disabled]="isEditClient">
                                                                </mat-checkbox>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="id">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-id" title="Client ID">Client ID
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-id">
                                                                <span class="text-ellipse"
                                                                    title="{{element.clientId ? element.clientId : '-'}}"
                                                                    [ngClass]="[(element.duplicateIDStatus === 1 || element.duplicateIDStatus === 2 || element.duplicateIDStatus === 3) ? 'grid-colorchange' : ' ']">
                                                                    {{ element.clientId ? element.clientId : '-' }}
                                                                </span>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="legalentityname">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-name" title="Entity Name">Entity
                                                                Name
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-name">
                                                                <span class="text-ellipse"
                                                                    title="{{element.legalEntityName}}">
                                                                    {{ element.legalEntityName }}
                                                                </span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="typeofentity">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-entity" title="Entity Type">Entity
                                                                Type
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-entity"
                                                                title="{{element.typeOfEntityName}}">
                                                                <span class="text-ellipse">
                                                                    {{ element.typeOfEntityName }}
                                                                </span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="Subtypeofentity">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-email" title="Entity Sub type">
                                                                Entity Sub type
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-email"
                                                                title="{{element.subentityname}}">
                                                                <span class="text-ellipse">
                                                                    {{ element.subentityname }}
                                                                </span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="incorporationdate">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-date" title="Incorporation Date">
                                                                Incorporation Date
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-date"
                                                                title="{{element.incorporationDate | appCountableTimeZone:'MM/dd/yyyy':'UTC'}}">
                                                                <span class="text-ellipse">{{ element.incorporationDate
                                                                    ? (element.incorporationDate |
                                                                    appCountableTimeZone:'MM/dd/yyyy':'UTC') : '-'
                                                                    }}</span>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="name">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-name" title="Contact Name">
                                                                Contact Name
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-name"
                                                                title="{{element.clientFirstName+' '+element.clientLastName}}">
                                                                <span lass="text-ellipse">{{ element.clientFirstName + '
                                                                    ' + element.clientLastName }}</span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="email">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-email" title="Email">Email
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-email"
                                                                title="{{element.clientEmail}}">
                                                                <a href="mailto:{{element.clientEmail}}" targrt="_top"
                                                                    class="text-ellipse text-link"
                                                                    [ngClass]="[(element.emailValidationStatus === 1 || element.emailValidationStatus === 2 || element.emailValidationStatus === 3) ? 'grid-colorchange' : ' ']">{{
                                                                    element.clientEmail }}</a>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="businessPhoneNo">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-number" title="Business Phone">
                                                                Business Phone
                                                            </th>
                                                            <td title="{{element.clientBusinessPhone ? element.clientBusinessPhone : '-'}}"
                                                                mat-cell *matCellDef="let element"
                                                                class="five-step-col-number">
                                                                <span class="text-ellipse"> {{
                                                                    element.clientBusinessPhone ?
                                                                    element.clientBusinessPhone :
                                                                    '-' }} </span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="cellPhoneNo">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="five-step-col-number" title="Cell Phone">
                                                                Cell Phone
                                                            </th>
                                                            <td title="{{element.clientCellPhone ? element.clientCellPhone : '-'}}"
                                                                mat-cell *matCellDef="let element"
                                                                class="five-step-col-number">
                                                                <span class="text-ellipse">{{ element.clientCellPhone ?
                                                                    element.clientCellPhone : '-' }}</span>
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="partner">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                class="text-end five-step-col-assign width-150"
                                                                title="Assigned Partner">
                                                                Assigned Partner
                                                            </th>
                                                            <td mat-cell *matCellDef="let element"
                                                                class="five-step-col-assign width-150 text-end">
                                                                <span
                                                                    class="text-ellipse width-110 text-end d-inline-block vertical-middle pe-1"
                                                                    title="{{element.engPartnerEmail ? element.engPartnerName : 'Unassigned'}}">
                                                                    {{ element.engPartnerEmail ? element.engPartnerName
                                                                    : 'Unassigned' }}
                                                                </span>
                                                                <button mat-button class="text-link"
                                                                    *ngIf="element.engPartnerEmail"
                                                                    (click)="openAssignPartner(element, 'assigned')"
                                                                    [matMenuTriggerFor]="reassignedMenu">
                                                                    <span
                                                                        class="badge badge-circle bg-secondary round-24">
                                                                        <i class="fa-regular fa-user-plus fs-12"></i>
                                                                    </span>
                                                                </button>
                                                                <button mat-button class="text-link"
                                                                    [matMenuTriggerFor]="assignedMenu"
                                                                    #allAssignMenu="matMenuTrigger"
                                                                    *ngIf="!element.engPartnerEmail"
                                                                    (click)="openAssignPartner(element, 'unassigned')">
                                                                    <span
                                                                        class="badge badge-circle bg-secondary round-24">
                                                                        <i class="fa-regular fa-user-plus fs-12"></i>
                                                                    </span>
                                                                </button>

                                                                <mat-menu #assignedMenu="matMenu" #beforeMenu="matMenu"
                                                                    xPosition="before" yPosition="below">
                                                                    <ng-container *ngIf="activeAssignPartner">
                                                                        <div class="h-100 overflow-hidden d-flex flex-column"
                                                                            (click)="$event.stopPropagation()">
                                                                            <form class="p-2 border-bottom">
                                                                                <mat-form-field
                                                                                    class="fixed-label label-none icon-form-before w-100 form-field-medium"
                                                                                    floatLabel="always">
                                                                                    <mat-label>Search</mat-label>
                                                                                    <input matInput placeholder="Search"
                                                                                        [(ngModel)]="searchFilter"
                                                                                        [ngModelOptions]="{standalone: true}"
                                                                                        (click)="$event.stopPropagation()"
                                                                                        autocomplete="off">
                                                                                    <span matPrefix>
                                                                                        <i class="fa-regular fa-magnifying-glass"
                                                                                            draggable="false"></i>
                                                                                    </span>
                                                                                </mat-form-field>
                                                                            </form>
                                                                            <ul class="templates-list-items h-100 overflow-auto"
                                                                                (click)="$event.stopPropagation()">
                                                                                <li class="list-item-content h-auto py-2"
                                                                                    *ngFor="let partner of partnersList  | searchFilter: searchFilter"
                                                                                    (click)="reAssignPartnerToClient(partner,element)">
                                                                                    <div
                                                                                        class="partner-view user-list-item">
                                                                                        <ngx-avatars size="24"
                                                                                            initialsSize="2"
                                                                                            [name]="partner.partnerFirstName+' '+partner.partnerLastName"></ngx-avatars>
                                                                                        <div class="item-content">
                                                                                            <p class="name"
                                                                                                title="{{partner.partnerFirstName+' '+partner.partnerLastName}}">
                                                                                                {{
                                                                                                partner.partnerFirstName
                                                                                                + ' ' +
                                                                                                partner.partnerLastName
                                                                                                }}</p>
                                                                                            <p class="role"
                                                                                                title="{{partner.partnerEmail}}">
                                                                                                {{ partner.partnerEmail
                                                                                                }}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <span
                                                                                        *ngIf="partner.partnerEmail === assignedPartner.engPartnerEmail"
                                                                                        title="{{partner.partnerEmail === element.engPartnerEmail}}">
                                                                                        <i
                                                                                            class="fa-regular fa-check text-primary"></i>
                                                                                    </span>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                        <!-- <ng-container *ngFor="let partner of partnersList | filter: searchFilter">
                                                                          <mat-list role="list" class="d-flex flex-column gap-8 mt-3 w-100 flex-nowrap">
                                                                            <mat-list-item  (click)="assignPartnerToCLient(partner)" >
                                                                                <span  class="d-flex flex-row align-items-start gap-8 flex-nowrap text-link">
                                                                                    <ngx-avatars size="24" initialsSize="2" [name]="partner.partnerFirstName+' '+partner.partnerLastName">
                                                                                    </ngx-avatars>
                                                                                <p class="d-flex flex-column gap-2 text-dark text-left fs-12">
                                                                                <span class="fs-10 text-primary">{{partner.partnerFirstName+' '+partner.partnerLastName}}</span>
                                                                                <span class="fs-12 text-gray-6">{{partner.partnerEmail}}</span>
                                                                                </p>
                                                                                <div class="float-right" *ngIf="partner.partnerEmail === assignedPartner.engPartnerEmail"
                                                                                title="{{partner.partnerEmail === element.engPartnerEmail}}">
                                                <i class="fa-regular fa-check done-icn"></i>
                                                                              </div>
                                                                                </span>
                                                                            </mat-list-item>
                                                                          </mat-list>

                                                                        </ng-container> -->
                                                                    </ng-container>
                                                                </mat-menu>

                                                                <mat-menu #reassignedMenu="matMenu"
                                                                    #beforeMenu="matMenu" xPosition="before"
                                                                    yPosition="below">
                                                                    <ng-container *ngIf="activeUnAssignPartner">
                                                                        <button mat-menu-item
                                                                            (click)="$event.stopPropagation();openReAssignPartner(assignedPartner)">
                                                                            Reassign
                                                                        </button>
                                                                        <button mat-menu-item
                                                                            (click)="unAssignPartnerToCLient(element)">
                                                                            Unassign
                                                                        </button>
                                                                    </ng-container>
                                                                    <ng-container *ngIf="activeAssignPartner">
                                                                        <div
                                                                            class="h-100 overflow-hidden d-flex flex-column">
                                                                            <form class="p-2 border-bottom">
                                                                                <mat-form-field
                                                                                    class="fixed-label label-none icon-form-before w-100 form-field-medium"
                                                                                    floatLabel="always">
                                                                                    <mat-label>Search</mat-label>
                                                                                    <input matInput placeholder="Search"
                                                                                        [(ngModel)]="searchFilter"
                                                                                        [ngModelOptions]="{standalone: true}"
                                                                                        (click)="$event.stopPropagation()"
                                                                                        autocomplete="off">
                                                                                    <span matPrefix>
                                                                                        <i class="fa-regular fa-magnifying-glass"
                                                                                            draggable="false"></i>
                                                                                    </span>
                                                                                </mat-form-field>
                                                                            </form>
                                                                            <ul
                                                                                class="templates-list-items h-100 overflow-auto">
                                                                                <li class="list-item-content h-auto py-2"
                                                                                    *ngFor="let partner of partnersList | searchFilter: searchFilter">
                                                                                    <div class="partner-view user-list-item"
                                                                                        (click)="reAssignPartnerToClient(partner,element)">
                                                                                        <ngx-avatars size="24"
                                                                                            initialsSize="2"
                                                                                            [name]="partner.partnerFirstName+' '+partner.partnerLastName"></ngx-avatars>
                                                                                        <div class="item-content">
                                                                                            <p class="name"
                                                                                                title="{{partner.partnerFirstName+' '+partner.partnerLastName}}">
                                                                                                {{
                                                                                                partner.partnerFirstName
                                                                                                + ' ' +
                                                                                                partner.partnerLastName
                                                                                                }}</p>
                                                                                            <p class="role"
                                                                                                title="{{partner.partnerEmail}}">
                                                                                                {{ partner.partnerEmail
                                                                                                }}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <span
                                                                                        *ngIf="partner.partnerEmail === assignedPartner.engPartnerEmail"
                                                                                        title="{{partner.partnerEmail === element.engPartnerEmail}}">
                                                                                        <i
                                                                                            class="fa-regular fa-check text-primary"></i>
                                                                                    </span>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                        <!-- <ng-container *ngFor="let partner of partnersList | filter: searchFilter">
                                                                          <mat-list role="list" class="d-flex flex-column gap-8 mt-3 w-100 flex-nowrap">
                                                                            <mat-list-item  (click)="assignPartnerToCLient(partner)" >
                                                                                <span  class="d-flex flex-row align-items-start gap-8 flex-nowrap text-link">
                                                                                    <ngx-avatars size="24" initialsSize="2" [name]="partner.partnerFirstName+' '+partner.partnerLastName">
                                                                                    </ngx-avatars>
                                                                                <p class="d-flex flex-column gap-2 text-dark text-left fs-12">
                                                                                <span class="fs-10 text-primary">{{partner.partnerFirstName+' '+partner.partnerLastName}}</span>
                                                                                <span class="fs-12 text-gray-6">{{partner.partnerEmail}}</span>
                                                                                </p>
                                                                                <div class="float-right" *ngIf="partner.partnerEmail === assignedPartner.engPartnerEmail"
                                                                                title="{{partner.partnerEmail === element.engPartnerEmail}}">
                                            <i class="fa-regular fa-check done-icn"></i>
                                                                              </div>
                                                                                </span>
                                                                            </mat-list-item>
                                                                          </mat-list>

                                                                        </ng-container> -->
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="actions" stickyEnd>
                                                            <th mat-header-cell *matHeaderCellDef class="text-center"
                                                                title="Actions">
                                                                Actions
                                                            </th>
                                                            <td mat-cell *matCellDef="let element" class="text-end">
                                                                <div class="table-button-group">
                                                                    <button mat-button class="button-text" title="Edit"
                                                                        (click)="editClient(element)"
                                                                        [disabled]="element.isChecked">
                                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                                    </button>
                                                                    <button mat-button class="button-text"
                                                                        title="Delete" (click)="openDeleteCli(element)"
                                                                        [disabled]="element.isEditMode || element.isChecked">
                                                                        <i class="fa-regular fa-trash-can"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row
                                                            *matHeaderRowDef="addClientColumns; sticky: true"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: addClientColumns;">
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="card-footer button-group justify-content-end">
                                            <button mat-button mat-flat-button color="primary"
                                                class="button-medium me-auto" (click)="activeStep2()">
                                                <span class="flexbox-row gap-8">
                                                    <i class="fa-regular fa-angle-left"></i>
                                                    <span class="button-label">Back</span>
                                                </span>
                                            </button>
                                            <button mat-button mat-stroked-button class="button-medium" color="dark"
                                                (click)="skipThirdStep()" matStepperNext>Skip
                                            </button>
                                            <button mat-button mat-flat-button class="button-medium" color="primary"
                                                [disabled]="onStep3ValidationClick()" (click)="validateThirdStep()"
                                                matStepperNext>
                                                <span class="flexbox-row gap-8">
                                                    <span class="button-label">
                                                        Go to Step 4
                                                    </span>
                                                    <i class="fa-regular fa-angle-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </mat-step>

                        <mat-step>
                            <ng-template matStepLabel>
                                <div class="title cust-font">Invite Team</div>
                            </ng-template>
                            <div class="stepper-body-main gap-24">
                                <ng-container>
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="header-left">
                                                <h5 class="title">Invite Team</h5>
                                            </div>
                                            <div class="float-right">
                                                <form class="form-group">
                                                    <mat-form-field
                                                        class="fixed-label label-none flex-1 icon-form-before"
                                                        floatLabel="always">
                                                        <mat-label>Search</mat-label>
                                                        <input matInput placeholder="Search"
                                                            (keyup)="applyInviteFilter($event.target.value)">
                                                        <span matPrefix>
                                                            <i class="fa-regular fa-magnifying-glass"
                                                                draggable="false"></i>
                                                        </span>
                                                    </mat-form-field>
                                                </form>
                                            </div>
                                        </div>

                                        <div class="card-body p-0">
                                            <div class="table-responsive">
                                                <table mat-table [dataSource]="inviteGridData"
                                                    class="table-countable checkbox-table">
                                                    <ng-container matColumnDef="checkbox">
                                                        <th mat-header-cell *matHeaderCellDef
                                                            class="five-step-col-checkbox">
                                                            <mat-checkbox (click)="$event.stopPropagation()"
                                                                [(ngModel)]="inviteAll"
                                                                (ngModelChange)="isInvitedAll()"></mat-checkbox>
                                                        </th>
                                                        <td mat-cell *matCellDef="let element"
                                                            class="five-step-col-checkbox">
                                                            <mat-checkbox (click)="$event.stopPropagation()"
                                                                [(ngModel)]="element.isInvite"
                                                                (ngModelChange)="isInvited()"></mat-checkbox>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="membername">
                                                        <th mat-header-cell *matHeaderCellDef class="five-step-col-name"
                                                            title="Member Name">Member Name
                                                        </th>
                                                        <td mat-cell *matCellDef="let element"
                                                            class="five-step-col-name"
                                                            title="{{element.partnerFirstName+' '+element.partnerLastName}}">
                                                            <p>{{ element.partnerFirstName + ' ' +
                                                                element.partnerLastName }}</p>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="role">
                                                        <th mat-header-cell *matHeaderCellDef class="five-step-col-name"
                                                            title="Category">Category
                                                        </th>
                                                        <td mat-cell *matCellDef="let element"
                                                            class="five-step-col-name" title="{{element.role}}">
                                                            <p> {{ element.role }}</p>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="title">
                                                        <th mat-header-cell *matHeaderCellDef class="five-step-col-name"
                                                            title="Title">Title
                                                        </th>
                                                        <td mat-cell *matCellDef="let element"
                                                            class="five-step-col-name" title="{{element.title}}">
                                                            <p> {{ element.title }}</p>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="email">
                                                        <th mat-header-cell *matHeaderCellDef
                                                            class="five-step-col-email" title="Email"> Email
                                                        </th>
                                                        <td mat-cell *matCellDef="let element"
                                                            class="five-step-col-email" title="{{element.clientEmail}}">
                                                            <a href="mailto:{{element.partnerEmail}}" target="_top"
                                                                class="ellipse tab-email text-link">{{
                                                                element.partnerEmail }}</a>
                                                        </td>
                                                    </ng-container>

                                                    <tr mat-header-row *matHeaderRowDef="step4Columns; sticky: true">
                                                    </tr>
                                                    <tr mat-row *matRowDef="let row; columns: step4Columns;"></tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="card-footer button-group">
                                            <button mat-button mat-flat-button color="primary" class="button-medium"
                                                matStepperPrevious (click)="activeStep3()" [disabled]="disableBack">
                                                <span class="flexbox-row gap-8">
                                                    <i class="fa-regular fa-angle-left"></i>
                                                    <span class="button-label">Back</span>
                                                </span>
                                            </button>
                                            <button mat-button mat-flat-button class="button-medium" color="primary"
                                                [disabled]="onCompleteValidationClick()" (click)="onboard()">
                                                Finish
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </mat-step>

                    </mat-stepper>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<ng-container *ngIf="!isLoaded">
    <div class="success-msg">
        <!-- <div class="elem-p">
          <div class="elem-c">
            <div class="ico-bg-circle-48">
              <span class="icon-tick"></span>
            </div>
          </div>
        </div> -->
        <span class="icon-outer mb-lg-4 mb-3 mx-auto bg-success-1">
            <svg width="20" height="17.5" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z"
                    fill="#37A77C" />
            </svg>
        </span>
        <div class="text-center">
            <h4 class="title mb-lg-4 mb-3 text-center">{{ user.businessName }} has been onboarded successfully</h4>
            <button mat-button mat-button mat-flat-button color="primary" type="button" (click)="redirectToLogin()">
                Back to Login
            </button>
        </div>
    </div>
</ng-container>

<ng-template #uploadCSV class="edit-container">
    <div class="countable-dialog w-100">
        <div mat-dialog-title class="dialog-header">
            <h4 class="title">
                Upload Team Members from Template
                <p class="text-error d-flex flex-row fs-12 align-items-center gap-4"
                    *ngIf="partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus || RequirefieldValidation">
                    <i class="fa-regular fa-circle-exclamation error-up fs-12"></i>
                    <span *ngIf="partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus"> {{
                        errorMessage }}
                        already exist. Please re-check the record information</span>
                    <span *ngIf="RequirefieldValidation">{{ errorMessage }} is Invalid.</span><br>
                </p>
            </h4>
            <button mat-button class="close" [mat-dialog-close]="false" (click)="clearImportPartnersData()"
                [ngClass]="{'nowarn':partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus}">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content table-responsive px-0" (click)="$event.stopPropagation()">
            <table mat-table [dataSource]="actualPartnersImportGridData"
                class="customized-sort table-countable table-rounded">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef title="Member ID"> Member Id</th>
                    <td mat-cell *matCellDef="let element" title="{{element.id}}">
                        <p
                            [ngClass]="[(element.duplicateIDStatus === 1 || element.duplicateIDStatus === 2 || element.duplicateIDStatus === 3 || element.isAlphanumericId) ? 'email-repeate' : ' ']">
                            {{ element.id }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef title="Category"> Category</th>
                    <td mat-cell *matCellDef="let element" title="{{element.role}}">
                        <p>{{ element.role }} </p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef title="Title"> Title</th>
                    <td mat-cell *matCellDef="let element" title="{{element.title}}">
                        <p> {{ element.title }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef title="Name"> Name</th>
                    <td mat-cell *matCellDef="let element"
                        title="{{element.partnerFirstName + ' ' + element.partnerLastName}}">
                        <p> {{ element.partnerFirstName + ' ' + element.partnerLastName }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef title="Email"> Email</th>
                    <td mat-cell *matCellDef="let element" title="{{element.partnerEmail}}">
                        <a href="mailto:{{element.partnerEmail}}" target="_top" class="ellipse tab-email text-link"
                            [ngClass]="[(element.emailValidationStatus === 1 || element.emailValidationStatus === 2 || element.emailValidationStatus === 3) ? 'email-repeate' : ' ']">
                            {{ element.partnerEmail }}
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="businessNumber">
                    <th mat-header-cell *matHeaderCellDef title="Business Phone"> Business Phone</th>
                    <td mat-cell *matCellDef="let element" title="{{element.partnerBusinessPhone}}">
                        <p> {{ element.partnerBusinessPhone }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cell">
                    <th mat-header-cell *matHeaderCellDef title="Cell Phone"> Cell Phone</th>
                    <td mat-cell *matCellDef="let element" title="{{element.PartnerCellNo}}">
                        <p> {{ element.PartnerCellNo }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="license">
                    <th mat-header-cell *matHeaderCellDef title="License No"> License No</th>
                    <td mat-cell *matCellDef="let element" title="{{element.licenseNo}}">
                        <p
                            [ngClass]="[(element.duplicateLicenseNoStatus === 1 || element.duplicateLicenseNoStatus === 2 || element.duplicateLicenseNoStatus === 3  || element.isAlphanumericId) ? 'email-repeate' : ' ']">
                            {{ element.licenseNo }}</p>
                    </td>
                </ng-container>


                <ng-container matColumnDef="rate">
                    <th mat-header-cell *matHeaderCellDef title="Hourly Rate">
                        <div class="flex-box-vc-hr"> Hourly Rate</div>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.hourlyRate | currency :'':''}}">
                        <div class="flex-box-vc-hr">
                            <p> {{ element.hourlyRate | currency :'':'' }}</p>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="access">
                    <th mat-header-cell *matHeaderCellDef title="Hourly Rate">
                        <div class="flex-box-vc-hr"> Access Type</div>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.accessType ? element.accessType : '-'}}">
                        <div class="flex-box-vc-hr">
                            <p> {{ element.accessType ? element.accessType : '-' }} </p>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef title="Actions" class="overflow-auto">
                        <div class="actions-items">Actions</div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="overflow-auto">
                        <div class="actions-items">
                            <!-- <button class="transparent-btn" title="Delete"
                              (click)="onDeleteImportedData(element);$event.stopPropagation()">
                        <i class="fa-regular fa-trash-can"></i>
                            </button> -->
                            <button mat-button title="Delete" class="button-small-icon-action"
                                (click)="onDeleteImportedData(element);$event.stopPropagation()">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="addPartnersColumns1"></tr>
                <tr mat-row *matRowDef="let row; columns: addPartnersColumns1;"
                    [ngClass]="[(row.emailValidationStatus === 1 || row.emailValidationStatus === 2 || row.emailValidationStatus === 3) ? 'tr-dup' : ' ', (row.duplicateIDStatus === 1 || row.duplicateIDStatus === 2 || row.duplicateIDStatus === 3 || row.isAlphanumericId) ? 'tr-dup' : ' ',(row.duplicateLicenseNoStatus === 1 || row.duplicateLicenseNoStatus === 2 || row.duplicateLicenseNoStatus === 3  || row.isAlphanumericId) ? 'tr-dup' : ' ']">
                </tr>
            </table>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group pt-4">
            <button mat-button mat-stroked-button class="button-medium flex-1" color="dark" [mat-dialog-close]="false"
                (click)="clearImportPartnersData()">
                Cancel
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1" color="primary" [mat-dialog-close]="true"
                [disabled]="partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus || RequirefieldValidation"
                (click)="combineWithPartners()"> Upload
            </button>
            <!-- <button mat-button mat-flat-button class="button-medium flex-1" color="primary" [mat-dialog-close]="true"
            [disabled]="partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus || RequirefieldValidation" (click)="combineWithPartners()"
            [ngClass]="{'disable-button': partnerImportEmailStatus || partnerImportIdStatus || partnerImportLicenseStatus || RequirefieldValidation}"
            >
      Upload
    </button> -->

        </div>
    </div>
</ng-template>
<!--step 3-->
<ng-template #uploadCSVCli>
    <div class="countable-dialog w-100">
        <div mat-dialog-title class="dialog-header">
            <!-- <span class="badge badge-primary badge-circle icon-bordered-primary">
                                          <i class="fa-regular fa-circle-info text-primary"></i>
            </span> -->
            <h4 class="title">Upload Clients from Template
                <p class="text-error d-flex flex-row fs-12 align-items-center gap-8"
                    *ngIf="clientImportEmailStatus || clientImportIdStatus || clientImportEntityStatus">
                    <i class="fa-regular fa-circle-exclamation error-up fs-12"></i>
                    <span> {{ clientErrMessage }} already exist. Please re-check the record information</span>
                </p>
            </h4>
            <button mat-button class="close" [mat-dialog-close]="false" (click)="clearImportClientsData()"
                [ngClass]="{'nowarn':clientImportEmailStatus || clientImportIdStatus}">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content table-responsive px-0">
            <table mat-table [dataSource]="clientsImportGridData" class="customized-sort table-countable table-rounded">
                <ng-container matColumnDef="cliId">
                    <th mat-header-cell *matHeaderCellDef title="Client ID"> Client ID</th>
                    <td mat-cell *matCellDef="let element" title="{{element.clientId}}">
                        <p
                            [ngClass]="[(element.duplicateIDStatus === 1 || element.duplicateIDStatus === 2 || element.duplicateIDStatus === 3 || element.isAlphanumericId) ? 'email-repeate' : ' ']">
                            {{ element.clientId }}</p>
                    </td>
                </ng-container>
                <!-- clientImportEntityStatus -->
                <ng-container matColumnDef="lentity">
                    <th mat-header-cell *matHeaderCellDef title="Entity Name"> Entity Name</th>
                    <td mat-cell *matCellDef="let element" title="{{element.legalEntityName}}">
                        <p
                            [ngClass]="[(element.duplicateEmailEntityStatus === 1 || element.duplicateEmailEntityStatus === 2 || element.duplicateEmailEntityStatus === 3) ? 'email-repeate' : ' ']">
                            {{ element.legalEntityName }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="tyentity">
                    <th mat-header-cell *matHeaderCellDef title="Entity Type"> Entity Type</th>
                    <td mat-cell *matCellDef="let element" title="{{element.typeOfEntityName}}">
                        <p> {{ element.typeOfEntityName }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="subtyentity" *ngIf="user.origin_country_id == 226">
                    <th mat-header-cell *matHeaderCellDef title="Entity Sub type"> Entity Sub type</th>
                    <td mat-cell *matCellDef="let element" title="{{element.SubtypeOfEntityName}}">
                        <p> {{ element.subentityname }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="incDate">
                    <th mat-header-cell *matHeaderCellDef title="Incorporation Date"> Incorporation Date</th>
                    <td mat-cell *matCellDef="let element"
                        title="{{element.incorporationDate | appCountableTimeZone:'MM/dd/yyyy':'UTC'}}">
                        <p> {{ element.incorporationDate | appCountableTimeZone:'MM/dd/yyyy':'UTC' }}</p>
                    </td>
                </ng-container>


                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef title="Contact Name"> Contact Name</th>
                    <td mat-cell *matCellDef="let element"
                        title="{{element.clientFirstName+' '+element.clientLastName}}">
                        <p>{{ element.clientFirstName + ' ' + element.clientLastName }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailcli">
                    <th mat-header-cell *matHeaderCellDef title="Email"> Email</th>
                    <td mat-cell *matCellDef="let element" title="{{element.clientEmail}}">
                        <a href="mailto:{{element.clientEmail}}" target="_top" class="ellipse tab-email text-link"
                            [ngClass]="[(element.emailValidationStatus === 1 || element.emailValidationStatus === 2 || element.emailValidationStatus === 3) ? 'email-repeate' : ' ']">{{
                            element.clientEmail }}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="busNo">
                    <th mat-header-cell *matHeaderCellDef title="Business Phone"> Business Phone</th>
                    <td mat-cell *matCellDef="let element" title="{{element.clientBusinessPhone}}">
                        <p>{{ element.clientBusinessPhone }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cellNoCli">
                    <th mat-header-cell *matHeaderCellDef title="Cell Phone"> Cell Phone</th>
                    <td mat-cell *matCellDef="let element" title="{{element.clientCellPhone}}">
                        <p> {{ element.clientCellPhone }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="partners">
                    <th mat-header-cell *matHeaderCellDef title="Assigned Partner"> Assigned Partner</th>
                    <td mat-cell *matCellDef="let element" title="{{element.engPartnerName}}">
                        <p>{{ element.engPartnerName }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef title="Actions" class="overflow-auto">
                        <div class="actions-items">Actions</div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="overflow-auto">
                        <div class="actions-items">
                            <button mat-button title="Delete" class="button-small-icon-action"
                                (click)="onDeleteImportedClientData(element);$event.stopPropagation()">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns3;"
                    [ngClass]="[(row.emailValidationStatus === 1 || row.emailValidationStatus === 2 || row.emailValidationStatus === 3) ? 'tr-dup' : ' ', (row.duplicateIDStatus === 1 || row.duplicateIDStatus === 2 || row.duplicateIDStatus === 3 || row.isAlphanumericId) ? 'tr-dup' : ' ', (row.duplicateEmailEntityStatus === 1 || row.duplicateEmailEntityStatus === 2 || row.duplicateEmailEntityStatus === 3) ? 'tr-dup' : ' ']">
                </tr>
            </table>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group pt-4">
            <button mat-button mat-stroked-button color="dark" class="button-medium flex-1" [mat-dialog-close]="false"
                (click)="clearImportClientsData()">
                Cancel
            </button>
            <button mat-button mat-flat-button color="primary" class="button-medium flex-1" [mat-dialog-close]="true"
                [disabled]="clientImportEmailStatus || clientImportIdStatus || clientImportEntityStatus"
                (click)="combineWithClients()">
                Upload
            </button>
            <!-- <button mat-button mat-flat-button color="primary" class="button-medium flex-1" [mat-dialog-close]="true"
              [disabled]="clientImportEmailStatus || clientImportIdStatus || clientImportEntityStatus"
              (click)="combineWithClients()"
              [ngClass]="{'disable-button': clientImportEmailStatus || clientImportIdStatus || clientImportEntityStatus}">
              Upload
            </button> -->
        </div>
    </div>
</ng-template>

<ng-template #howtoEdit *ngIf="true">
    <div class="countable-dialog" (click)="$event.stopPropagation();" style="width: 800px;">
        <div mat-dialog-title class="dialog-header">
            <h4 class="title">STEPS FOR HOW TO CREATE A TEMPLATE (TEAM MEMBERS)</h4>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            <ol>
                <li> Click on ‘Download Template’ button</li>
                <div class="d-flex gap-8">
                    <i class="fa-regular fa-cloud-arrow-down upload-ico"></i>
                    <span>Download Template</span>
                </div>

                <li> A csv file will be downloaded</li>
                <li> Navigate to local location and open the csv file in Ms-excel</li>
                <li> Below are the column header names available:
                    <ol style="margin-left: -20px;" type="a">
                        <li><span class="fw-bold">Title</span><span class="text-error">*</span><span class="fw-bold">
                                :</span> Enter your Title (Example: Partner).
                        </li>
                        <li><span class="fw-bold">Member ID:</span> Enter your Member ID(Example: 1234).</li>
                        <li><span class="fw-bold">First Name</span><span class="text-error">*</span><span
                                class="fw-bold"> :</span> Enter your First Name (Example: Robert).
                        </li>
                        <li><span class="fw-bold">Last Name</span><span class="text-error">*</span><span
                                class="fw-bold"> :</span> Enter your Last Name (Example: Downey).
                        </li>
                        <li><span class="fw-bold">Email</span><span class="text-error">*</span><span class="fw-bold">
                                :</span>
                            Enter your Email (Example: xyz+12/ag3&#64;gmail.com).
                        </li>
                        <li><span class="fw-bold">Business Phone:</span> Enter your Business Phone (Example:
                            1234563030).
                        </li>
                        <li><span class="fw-bold">Cell Phone:</span> Enter your Cell Phone (Example: 915612350).</li>
                        <li><span class="fw-bold">License No:</span> Enter your License No (Example: 12345).</li>
                        <li><span class="fw-bold">Hourly Rate:</span> Enter your Hourly rate (Example: 60).</li>
                        <li><span class="fw-bold">Category</span><span class="text-error">*</span><span class="fw-bold">
                                :</span>
                            Enter your Category (Example: Partner).
                        </li>
                        <li><span class="fw-bold">Access Type</span><span class="text-error">*</span><span
                                class="fw-bold"> :</span>Enter your Access Type (Example: Super Admin).
                        </li>
                        <li><span class="text-error">*</span> included columns are mandatory.</li>
                    </ol>
                    <div>
                        <img src="../../../../assets/images/firm-partner1.PNG" alt="firm-staff-table" />
                    </div>
                </li>
                <li> Add your rows under header and save</li>
                <img src="../../../../assets/images/firm-partner.PNG" alt="firm-staff-table" />
                <div class="d-flex">
                    By clicking on save button,
                    <i class="fa-regular fa-floppy-disk text-black-8 fs-20"></i>
                    <p> File will be saved</p>
                </div>
                <li> Navigate to the location where the file is saved</li>
                <li> Drag and drop the file in ‘export icon’ field</li>
                <div>
                    <img style="width: 373px;" src="../../../../assets/images/drag-drop-fm.PNG" alt="drag-drop" />
                </div>
                <li>After importing the file, document will be in table format</li>
            </ol>

        </div>
        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button color="primary" class="button-medium flex-1"
                (click)="downloadPDF('partner')" [mat-dialog-close]="true">
                <svg id="get_app-24px" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                    <path id="Path_14559" data-name="Path 14559" d="M0,0H21V21H0Z" fill="none" />
                    <path id="Path_14560" data-name="Path 14560"
                        d="M16,7.941H12.857V3H8.143V7.941H5l5.5,5.765ZM5,15.353V17H16V15.353Z" fill="#a7c4cb" />
                </svg>
                Download as PDF
            </button>
            <button mat-button mat-flat-button color="primary" target="_blank" class="button-medium flex-1"
                [mat-dialog-close]="false">Close
            </button>
        </div>
    </div>
</ng-template>

<ng-template #howToEditCsv *ngIf="true">
    <div class="countable-dialog" (click)="$event.stopPropagation();" style="width: 800px;">
        <div mat-dialog-title class="dialog-header">
            <h4 class="title">STEPS FOR HOW TO CREATE A TEMPLATE (CLIENT)</h4>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            <ol type="1">
                <li> Click on ‘Download Template’ button</li>
                <div class="d-flex">
                    <svg id="get_app-24px" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                        viewBox="0 0 21 21">
                        <path id="Path_14559" data-name="Path 14559" d="M0,0H21V21H0Z" fill="none" />
                        <path id="Path_14560" data-name="Path 14560"
                            d="M16,7.941H12.857V3H8.143V7.941H5l5.5,5.765ZM5,15.353V17H16V15.353Z" fill="#a7c4cb" />
                    </svg>
                    <span style="margin-left: 10px;"><span>Download Template</span>
                    </span>
                </div>
                <li>A csv file will be downloaded</li>
                <li>Navigate to local location and open the csv file in Ms-excel</li>
                <li>Below are the column header names available:</li>
                <ol style="margin-left: -20px;" type="a">
                    <li><span class="fw-bold">Client Id</span><span class="text-error">*</span><span class="fw-bold">
                            :</span> Enter your Client Id (Example: 3030).
                    </li>
                    <li><span class="fw-bold">Entity Name</span><span class="text-error">*</span><span class="fw-bold">
                            :</span>
                        Enter your Entity Name (Example: Holmes lnc).
                    </li>
                    <li><span class="fw-bold">Entity Type</span><span class="text-error">*</span><span class="fw-bold">
                            :</span>
                        Enter your Entity Type (Example: Corporation ).
                    </li>
                    <ol style="margin-left: -20px;" type="i">
                        <li>Corporation</li>
                        <li>Partnership</li>
                        <li>Sole Proprietor</li>
                        <li>Trust</li>
                    </ol>
                    <li><span class="fw-bold">Incorporation Date:</span> Enter your Incorporation Date (Example:
                        Mar-23-2016).
                    </li>
                    <li><span class="fw-bold">First Name</span><span class="text-error">*</span><span class="fw-bold">
                            :</span> Enter your First Name (Example: Robert).
                    </li>
                    <li><span class="fw-bold">Last Name</span><span class="text-error">*</span><span class="fw-bold">
                            :</span> Enter your Last Name (Example: Downey).
                    </li>
                    <li><span class="fw-bold">Email</span><span class="text-error">*</span><span class="fw-bold">
                            :</span>
                        Enter your Email (Example: xyz+12/ag3&#64;gmail.com).
                    </li>
                    <li><span class="fw-bold">Business Phone:</span> Enter your Business Phone (Example: 1234563030).
                    </li>
                    <li><span class="fw-bold">Cell Phone:</span> Enter your Cell Phone (Example: 1234563030).</li>
                    <li><span class="fw-bold">Address:</span> Enter your Address (Example:111/333 Amphoe ).</li>
                    <li><span class="fw-bold">City:</span> Enter your City (Example:Chanthapuri).</li>
                    <li><span class="fw-bold">State/Province:</span> Enter your State/Province (Example: Chanthapuri).
                    </li>
                    <li><span class="fw-bold">Country:</span> Enter your Country (Example:Thailand).</li>
                    <li><span class="fw-bold">Postal Code:</span> Enter your Postal Code (Example: 22000).</li>
                    <li><span class="fw-bold">Engagement Partner:</span> Enter your Engagement Partner (Example: John
                        Paul).
                    </li>
                    <li><span class="fw-bold">Engagement Partner Email:</span> Enter your Engagement Partner Email
                        (Example:
                        xyz+12/ag3&#64;gmail.com).
                    </li>
                    <li><span class="fw-bold">Group Name:</span> Enter your Group Name (Example: Holmes group).</li>
                    <div><span class="text-error">*</span> included columns are mandatory.</div>
                    <div>
                        <img src="../../../../assets/images/firm-client2.PNG" alt="firm-cli-table" />
                        <img src="../../../../assets/images/firm-client3.PNG" alt="firm-cli-table" />
                    </div>
                </ol>
                <li>Add your rows under header and save
                <li>
                    <div>
                        <img src="../../../../assets/images/firm-client4.PNG" alt="firm-cli-table" />
                        <img src="../../../../assets/images/firm-client5.PNG" alt="firm-cli-table" />
                        <div class="d-flex">
                            By clicking on save button,
                            <i class="fa-regular fa-floppy-disk text-black-8 fs-20"></i>
                            <p> File will be saved</p>
                        </div>
                    </div>
                <li>Navigate to the location where the file is saved</li>
                <li>Drag and drop the file in ‘export icon’ field</li>
                <div>
                    <img src="../../../../assets/images/drag-drop-fm.PNG" alt="drag-drop" />
                </div>
                <li>After importing the file, document will be in table format</li>
            </ol>
        </div>
        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button color="primary" class="button-medium flex-1"
                (click)="downloadPDF('client')" [mat-dialog-close]="true">
                <svg id="get_app-24px" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                    <path id="Path_14559" data-name="Path 14559" d="M0,0H21V21H0Z" fill="none" />
                    <path id="Path_14560" data-name="Path 14560"
                        d="M16,7.941H12.857V3H8.143V7.941H5l5.5,5.765ZM5,15.353V17H16V15.353Z" fill="#a7c4cb" />
                </svg>
                Download as PDF
            </button>
            <button mat-button mat-flat-button color="primary" target="_blank" class="button-medium flex-1"
                [mat-dialog-close]="false">Close
            </button>
        </div>
    </div>
</ng-template>


<!-- <ng-template #DeleteActionDialog>
  <div class="countable-dialog" style="width:400px">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error">
              <i class="fa-regular fa-trash-can text-error"></i>
    </span>

    <h4 class="title text-center">Delete Team Member</h4>
  <button color="error" class="close" [mat-dialog-close]="false">
      <i class="fa-regular fa-xmark clear-icon"></i>
  </button>
  </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>{{confirmMessage}}
    Do you want to continue?</p>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group w-100">
        <button mat-button mat-stroked-button class="button-medium flex-1" color="dark"
        [mat-dialog-close]="false">No</button>
        <button mat-button mat-flat-button class="button-medium flex-1 m-0" color="error" [mat-dialog-close]="true"
          (click)="onEditDelete()">
          Yes
        </button>
    </div>
  </div>
</ng-template> -->

<ng-template #alertDialog>
    <div class="countable-dialog" (click)="$event.stopPropagation();" style="width:400px">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-triangle-exclamation"></i>
            </span>
            <h4 class="title text-center">Unsaved Changes</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8">
            <p>There are unsaved changes.
                Do you really wish to go import?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button mat-button mat-stroked-button class="button-medium flex-1" color="dark" [mat-dialog-close]="false"
                (click)="changeProcessType()"> No
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1 m-0" color="primary"
                [mat-dialog-close]="true" (click)="resetForm(formType)">Yes
            </button>
        </div>
    </div>
</ng-template>

<ng-template #alertDialog1>
    <div class="countable-dialog" (click)="$event.stopPropagation();" style="width:400px">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-triangle-exclamation"></i>
            </span>
            <h4 mat-dialog-title dialogbox class="title text-center">Unsaved Changes</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8">
            <p>There are unsaved changes.
                Do you really wish to go back?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button mat-button mat-stroked-button class="button-medium flex-1" color="dark" [mat-dialog-close]="false"
                (click)="preventBackbutton(fromBackType)">No
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1 m-0" color="primary"
                [mat-dialog-close]="true" (click)="goBack(backType, fromBackType)"> Yes
            </button>
        </div>

    </div>
</ng-template>

<ng-template #importCsvDialog>
    <h4 mat-dialog-title class="flex-box-left" style="display: flex !important;">
        <i class="fa-regular fa-circle-xmark text-warning-darker"></i>
        <span>Licence column not valid in Sheet</span>
    </h4>
    <div mat-dialog-content>
        <div class="flex-box-left" style="align-items: flex-start;">
            <i class="fa-regular fa-tag mt-1"></i>
            <p>Please enter Only Numeric and Max 11 Numeric in Licence Column</p>
        </div>
        <div class="flex-box-left" style="align-items: flex-start;">
            <i class="fa-regular fa-tag mt-1"></i>
            <p>Please enter Only Unique Licence Number in Licence Column</p>
        </div>

    </div>
    <div mat-dialog-actions>
        <div class="flex-box full-row">
            <button mat-flat-button color="primary" [mat-dialog-close] cdkFocusInitial>Ok</button>
        </div>
    </div>
</ng-template>

<ng-template #DeleteActionDialog>
    <div class="countable-dialog" style="width:400px">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>

            <h4 class="title text-center">Delete Team Member</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8">
            <p>{{ confirmMessage }}
                Do you want to continue?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button mat-button mat-stroked-button class="button-medium flex-1" color="dark"
                [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1 m-0" color="error" [mat-dialog-close]="true"
                (click)="onEditDelete()">
                Yes
            </button>
        </div>
    </div>
</ng-template>

<ng-template #DeleteActionClientDialog>
    <div class="countable-dialog" style="width: 400px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>

            <h4 class="title text-center"> Delete Client</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8">
            <p>You are trying to delete client.
                Do you want to continue?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button mat-button mat-stroked-button class="button-medium flex-1" color="dark"
                [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1 m-0" color="error" [mat-dialog-close]="true"
                (click)="deleteClient()">
                Yes
            </button>
        </div>
    </div>
</ng-template>
